import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";

const SLOT_PROVIDERS_STALE_TIME_MS = 60 * 1000;

const useSlotProviders = () => {
  const { apiService } = useAppContext();
  return useQuery<string[]>({
    queryKey: ["slot-games-providers"],
    queryFn: async () => {
      const response = await apiService.request(`/slots/providers`, {
        method: "GET",
      });

      const result = await response?.json();

      if (!response?.ok) {
        return Promise.reject([]);
      }

      return result.data;
    },
    initialData: [],
    initialDataUpdatedAt: 0,
    placeholderData: (data) => data,
    staleTime: SLOT_PROVIDERS_STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });
};

export default useSlotProviders;
